import { Component, Input, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { jkLib } from '../../services/jkCommon';
import { JkBaseComponent } from '../jkbase/jkbase.component';

@Component({
  selector: 'app-jkstarmark',
  standalone: true,
  imports: [MatChipsModule,MatIconModule
   // ,MatLabel
  ],
  templateUrl: './jkstarmark.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jkstarmark.component.scss'
})
export class JkstarmarkComponent extends JkBaseComponent implements OnInit{
  override comType: string = 'jkstarmark';
  readonly onClick = output<any>(); //: (item: any,isUpdate:boolean) => void;
  chipClick(item: any): void {
    if (this.onClick) {
      this.onClick.emit(item);
    }
  }
  constructor() {
    super();
  }
  readonly isUpdate = input<boolean>(false);
  override ngOnInit() {
    super.ngOnInit();
  }
  _value: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get value(): string {
    return this._value;
  }
  set value(val: string) {
    this._value = val;
  }
  doClick(item: any): void {
    this.chipClick(item);

  }
  showStar(s:string):string{
    return jkLib.showStar(s);
  }

}
